const note = {
    version: '1.0.1',
    date: '2026-08-31',
    tags: ['Fix'],
    body: `
- **Billing Type følger nu work type.** Kalenderen satte selv en timelog til Non Billable. Nu følger den den work type, du vælger, og CapLegal er fortsat facit.
`,
};

export default note;
